import React from 'react'
import { FormSectionTitle } from '@paintscout/ui'
import type { QuoteItemSection } from '@paintscout/util/builder'
import type { PresentationBlockProps } from '../..'
import FilesByItem from '../../../Quote/FilesByItem'

/**
 * A live gallery of the quote's own job pictures — no configurable fields, entirely derived
 * from the quote in context (matches v1's Pictures block exactly, just reused directly since
 * FilesByItem is shared, not v1-only).
 */
export default function PicturesBlock(props: PresentationBlockProps) {
  const { WrapperComponent } = props
  const consumer = 'customer'
  const sections = ['bid', 'additional', 'added-options', 'pending', 'options'] as QuoteItemSection[]

  return (
    <WrapperComponent {...props}>
      <FilesByItem
        FormSectionTitle={<FormSectionTitle title={'Media'} style={{ marginBottom: 0 }} />}
        sections={sections}
        consumer={consumer}
        WrapperComponent={WrapperComponent}
      />
    </WrapperComponent>
  )
}
